import { Link, Spinner } from "@chakra-ui/react";
import { TextArea } from "components/FormInputs/TextArea";
import { Button } from "newui/components/Button";
import { FieldForm } from "components/RFQ/Input";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useCurrentCompanyId } from "hooks/auth";

export const SupplierSelector = ({
	additionalMessage,
	supplierList,
	unCheckedList,
	handleAdditionalMessageChange,
	handleSubmit,
	handleSupplierChange,
}) => {
	const InitialValueModal = {
		supplier: "",
	};
	const companyId = useCurrentCompanyId();
	const validationSchema = yup.object().shape({
		supplier: yup.number().required("This field is required"),
	});

	return (
		<Formik
			initialValues={InitialValueModal}
			onSubmit={handleSubmit}
			validationSchema={validationSchema}
		>
			{({ isSubmitting, isValid, dirty }) => (
				<Form className="space-y-8">
					<FieldForm
						label="Supplier"
						name="supplier"
						type="select"
						options={unCheckedList}
						isDisabled={unCheckedList?.length < 1}
						placeholder={
							unCheckedList?.length > 0 ? "Select Supplier" : "No Supplier left"
						}
						onChange={handleSupplierChange}
					/>
					<TextArea
						value={additionalMessage}
						label="Additional Message"
						name="additional_message"
						placeholder="Additional Message"
						className="flex flex-col"
						onChange={handleAdditionalMessageChange}
					/>
					<div className="rounded-xl bg-utility-blue-light-100 px-6 py-5">
						<p className="text-secondary-700">
							{unCheckedList?.length > 0
								? "You are adding suppliers"
								: "All suppliers"}{" "}
							from “{supplierList?.name}” list
							{unCheckedList?.length < 1 && " are invited"}. Manage your{" "}
							<Link
								to={`/account/${companyId}/supplier-list/${supplierList?.id}/${supplierList?.name}`}
								className="text-secondary-700 underline"
							>
								supplier list
							</Link>{" "}
							if you want to add a new supplier.
						</p>
					</div>
					<Button
						className="mt-3"
						style={{ width: "100%" }}
						type="submit"
						disabled={!isValid || !dirty || isSubmitting}
					>
						{isSubmitting ? <Spinner></Spinner> : "Invite Supplier"}
					</Button>
				</Form>
			)}
		</Formik>
	);
};
